import { apiErrorMessage } from '@/lib/checkout/outcome'

/** F-233: what a refused code or send means to the person (login step, step-up modal, setup). `suggestRecovery`: sending is blocked for now (429). */
export const twoFactorFailure = (error: unknown, t: (key: string, vars?: Record<string, unknown>) => string): { text: string; suggestRecovery: boolean; param: string | null } => {
  const { message, status, param, data } = apiErrorMessage(error)
  const attemptsLeft = (data as { attemptsLeft?: unknown } | null)?.attemptsLeft
  if (status === 400 && param === 'code' && typeof attemptsLeft === 'number') {
    return { text: attemptsLeft > 0 ? t('code.wrong', { count: attemptsLeft }) : t('code.noAttemptsLeft'), suggestRecovery: false, param }
  }
  if (status === 429) return { text: message || t('code.tooMany'), suggestRecovery: true, param }
  return { text: message || t('code.failed'), suggestRecovery: false, param }
}
